import _slicedToArray from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Adds leading zero to month/day if necessary, returns 'YYYY' if type = 'year',
// 'YYYY-MM' if 'month' and 'YYYY-MM-DD' if 'date'
import pad from './pad';
export default (function (dateString, type) {
  var _dateString$split = dateString.split('-'),
    _dateString$split2 = _slicedToArray(_dateString$split, 3),
    year = _dateString$split2[0],
    _dateString$split2$ = _dateString$split2[1],
    month = _dateString$split2$ === void 0 ? 1 : _dateString$split2$,
    _dateString$split2$2 = _dateString$split2[2],
    date = _dateString$split2$2 === void 0 ? 1 : _dateString$split2$2;
  return "".concat(year, "-").concat(pad(month), "-").concat(pad(date)).substr(0, {
    date: 10,
    month: 7,
    year: 4
  }[type]);
});